import { createAsyncThunk } from "@reduxjs/toolkit";
import { cloudChiprApi } from "@/services/cloudchipr.api";
import { RootState } from "@/store/store";
import { isDeepEqual } from "@/utils/is-deep-equal";
import { dimensionSharedCostsSelector } from "@/store/dimensions/selectors/slice-data/shared-costs/dimensionSharedCostsSelector";
import { generateSharedCostPayload } from "@/store/dimensions/utils/helpers/generateSharedCostPayload";
import { dimensionSharedCostsDataSelector } from "@/store/dimensions/selectors/shared-costs/dimensionSharedCostsDataSelector";
import { convertSharedCostsArrayToObjectByIds } from "@/store/dimensions/thunks/dimensions/update-current-dimension/shared-costs/convertSharedCostsArrayToObjectByIds";

export const findAndUpdateChangedSharedCostsThunk = createAsyncThunk(
  "dimensions/findAndUpdateChangedSharedCosts",
  async (dimensionId: string, { dispatch, getState }) => {
    const state = getState() as RootState;
    const dimensionSharedCosts = dimensionSharedCostsSelector(state);

    const originalSharedCosts = dimensionSharedCostsDataSelector(state);

    if (!originalSharedCosts) {
      return;
    }

    const originalSharedCostsObj =
      convertSharedCostsArrayToObjectByIds(originalSharedCosts);

    // find shared cost that has changes
    const sharedCostsToUpdate = dimensionSharedCosts.filter((sharedCost) => {
      if (!originalSharedCostsObj[sharedCost.id]) {
        return false;
      }

      const original = originalSharedCosts.find((originalSharedCost) => {
        return originalSharedCost.id === sharedCost.id;
      });

      if (original) {
        return !isDeepEqual(original, sharedCost);
      } else {
        return false;
      }
    });

    if (!dimensionId || !sharedCostsToUpdate?.length) {
      return;
    }

    // update shared cost that has changes
    const promises = sharedCostsToUpdate.map((sharedCost) => {
      return dispatch(
        cloudChiprApi.endpoints.putUsersMeOrganisationsCurrentDimensionsByDimensionIdDimensionSharedCostsAndSharedCostId.initiate(
          {
            dimensionId,
            sharedCostId: sharedCost.id,
            body: generateSharedCostPayload(sharedCost),
          },
        ),
      ).unwrap();
    });

    await Promise.all(promises);
  },
);
